import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import { googleAds } from "appConfig";

import styles from "./styles/ModulePage.scss";
import getWidthContext from "../../HOCs/getWidthContext";
import {
  CategoryNameHr,
  ModuleName,
  ModuleNameHr,
  PageRoute,
  QueryParam
} from "../../models";
import history from "../../history";
import { checkEmptyObject, isMobileScreen, stringifyURI } from "../../services/utils";
import {
  selectCurrentCategories,
  selectCurrentModule,
  selectCurrentModuleName
} from "../App/selectors";
import { NewAdsSection } from "./NewAdsSection";
import { DiscountedAdsSection } from "./DiscountedAdsSection";
import { CategorySection } from "./CategorySection";
import BreadcrumbBar from "../../components/BreadcrumbBar";
import HelmetComponent from "../../utils/HelmetHelper";
import ModuleSearchSection from "./ModuleSeaarchSection";
import { handleSearchPage } from "../../routes/Search";
import { deleteControls } from "../../routes/Search/search.ducks";
import { updateCurrentModule } from "../App/actions";
import GoogleAd from "../../components/GoogleAd";
import GoogleAdInterstitial from "../../components/GoogleAdInterstitial";
import FeaturedStoresWidget, { useFeaturedStoresWillRender } from "../../components/FeaturedStoresWidget";
import RealEstatePricesEntryBox from "./RealEstatePricesEntryBox";
import { isPropertyTypeSlug } from "../RealEstatePricesPage/helpers";

const moduleInRoute = ModuleNameHr.realEstate;

function ModulePage(props: any) {
  const {
    match: {
      params: { category }
    },
    width,
    module,
    moduleName,
    showHeaderLogoAndSearchBar,
    selectedCategories,
    deleteControls,
    metaData
  } = props;

  const [routeLinks, setRouteLinks] = useState([]);
  const [isSearch, setIsSearch] = useState(module == moduleInRoute);
  const willShowFeaturedStores = useFeaturedStoresWillRender();
  showHeaderLogoAndSearchBar();

  useEffect(() => {
    const {
      location: { pathname }
    } = props;

    if (pathname === `/${ModuleNameHr.realEstate}`) {
      // Real estate module must contain a category behind.
      history.replace(`${ModuleNameHr.realEstate}/${CategoryNameHr.housesForSale}`);
    }

    deleteControls();
  }, []);

  useEffect(() => {
    const { module, moduleName } = props;
    if (module) {
      if (
        module == ModuleNameHr.tourism ||
        module == ModuleName.tourism
      ) {
        const query = {
          module: ModuleNameHr.tourism,
          category: CategoryNameHr.apartmentsRoomsHouses
        };
        history.replace(`/${module}/${CategoryNameHr.apartmentsRoomsHouses}${PageRoute.search
          }$${stringifyURI(query, QueryParam.searchQuery)}`);
      } else if (
        (
          module == ModuleNameHr.realEstate ||
          module == ModuleName.realEstate
        ) && !location.pathname.split("/")[3] && location.pathname.split("/")[2] == ModuleNameHr.realEstate
      ) {
        history.replace(`/${module}/${CategoryNameHr.housesForSale}`);
      }
      setRouteLinks([{ title: moduleName }]);
    }
  }, [moduleName === undefined ? true : false]);

  const isMobile = isMobileScreen(width);

  const renderSearchSection = (isMobile: boolean) => {
    const {
      match: {
        params: { category }
      },
      ads,
      categories,
      criteriaModules,
      isMakePage,
      level,
      loading,
      location,
      module,
      modules,
      numberOfControls,
      onResetAllTags,
      onSearchSubmit,
      onTagRemove,
      selectedCategories,
      selectedCategory,
      subLevelSearch,
      tags,
      updateCriteriaModules
    } = props;

    return (
      <ModuleSearchSection
        ads={ads}
        categories={categories}
        categoryName={category}
        category={category}
        criteriaModules={criteriaModules}
        isMakePage={isMakePage}
        isMobile={isMobile}
        level={level}
        levelCount={selectedCategories}
        loading={loading}
        location={location}
        module={module}
        modules={modules}
        numberOfControls={numberOfControls}
        onBoxClick={props.deleteSubLevelSearch}
        onResetAllTags={onResetAllTags}
        onSubmit={onSearchSubmit}
        onTagRemove={onTagRemove}
        selectedCategory={selectedCategory}
        subLevelSearch={subLevelSearch}
        tags={tags}
        updateCriteriaModules={updateCriteriaModules}
      />
    );
  };

  if (!metaData) {
    return null;
  }

  return (
    <React.Fragment>
      {checkEmptyObject(metaData) ? (
        <HelmetComponent
          title={checkEmptyObject(metaData) && metaData.title}
          desc={checkEmptyObject(metaData) && metaData.description}
        />
      ) : (
        <HelmetComponent
          title={`${"Odaberite kategoriju"} | ${"INDEX OGLASI"}`}
        />
      )}
      {isMobile && (
        <GoogleAdInterstitial
          config={{
            ...googleAds.interstitialSlot,
            id: "googleAds.interstitialSlot"
          }}
        />
      )}
      <BreadcrumbBar
        className={styles.breadcrumb}
        routeLinks={routeLinks}
        category={module}
      />
      <div className={styles.titleHolder}>
        {checkEmptyObject(metaData) && metaData.h1 && (
          <h1 className={styles.title}>{metaData.h1}</h1>
        )}
      </div>

      <div style={{ marginTop: 20 }}>
        {isMobile ? (
          <GoogleAd
            className={`${styles.ads} ${styles.adPlaceholder}`}
            config={{
              ...googleAds.navigationMobile.box1,
              id: "googleAds.navigationMobile.box1"
            }}
          />
        ) : (
          <GoogleAd
            className={`${styles.ads} ${styles.adPlaceholder} ${styles.adPlaceholderFirst}`}
            config={{
              ...googleAds.navigation.top,
              id: "googleAds.navigation.top"
            }}
          />
        )}
      </div>

      <div className={`child-center ${styles.container}`}>
        {isSearch ? (
          renderSearchSection(isMobile)
        ) : (
          <CategorySection categories={selectedCategories} module={module} />
        )}
        {isMobile ? (
          <GoogleAd
            className={styles.ads}
            config={{
              ...googleAds.navigationMobile.box2,
              id: "googleAds.navigationMobile.box2"
            }}
            noBottomMargin={true}
          />
        ) : (
          <GoogleAd
            className={styles.ads}
            config={{
              ...googleAds.navigation.bottom1,
              id: "googleAds.navigation.bottom1"
            }}
            noBottomMargin={true}
          />
        )}
        {module == ModuleNameHr.realEstate && isPropertyTypeSlug(category, selectedCategories) && (
          <RealEstatePricesEntryBox category={category} flushBottom={willShowFeaturedStores} />
        )}
        {category && (
          <FeaturedStoresWidget module={module} category={category} isMobile={isMobile} />
        )}
        {category && <DiscountedAdsSection isMobile={isMobile} module={module} category={category} />}
        <NewAdsSection isMobile={isMobile} module={module} category={category} />
      </div>
      {isMobile ? (
        <GoogleAd
          className={styles.ads + " " + styles.adsBottom}
          config={{
            ...googleAds.navigationMobile.box3,
            id: "googleAds.navigationMobile.box3"

          }}
        />
      ) : (
        <GoogleAd
          className={styles.ads + " " + styles.adsBottom}
          config={{
            ...googleAds.navigation.bottom2,
            id: "googleAds.navigation.bottom2"
          }}
        />
      )}
    </React.Fragment>
  );
}

export default connect(
  (state: any) => ({
    selectedCategories: selectCurrentCategories(state),
    module: selectCurrentModule(state),
    moduleName: selectCurrentModuleName(state)
  }),
  { deleteControls, updateCurrentModule }
)(handleSearchPage(getWidthContext(ModulePage)));



// WEBPACK FOOTER //
// ./src/containers/ModulePage/index.tsx